import Event from '../../core/Event';

export default class OrderDetailRequested extends Event {
    public static type = 'OrderDetailRequested';

    constructor(public readonly orderId: string, public readonly customerId: string) {
        super(OrderDetailRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderDetailRequested.ts